export default __webpack_public_path__ + "static/media/TetrisTheme.91054c04.mp3";